const SESSION_KEYS = ['token', 'refreshToken', 'userInfo', 'permissions', 'role', 'user', 'userDetails'];

/** Removes every piece of authentication state persisted in the browser. */
export function clearSession(): void {
  for (const key of SESSION_KEYS) {
    localStorage.removeItem(key);
  }
  sessionStorage.clear();
}
